import { sendAnalyticsData } from "../../utility/levarAnalytics";

export const setClosingThunk = () => {
  return async (dispatch, getState) => {
    const { origin, referrer, session_id, hash, variant, product_id } = getState();

    if(origin === 'external' && session_id.length > 0) {
      await sendAnalyticsData({ session_id, hash, variant, event_type: 'viewer_page_exit', referrer, product_id });
      window.location.assign(`${referrer}&levar_session_id=${session_id}`);
    } else if(origin === 'external') {
      window.location.assign(referrer);
    } else if(origin === 'shopify') {
      window.parent.postMessage('levarViewerClose', '*');
    }
  }
};
